import React from "react";
import { PrefillInput } from "@components/input";

const FirstName = () => (
  <PrefillInput
    title="First Name"
    placeholder="First Name"
    name="firstName"
  />
);

export default FirstName;